

export const convertStripeKycRequirementsToReadableTexts = async (requirements) => {
    
    const setTxtV2 = (await import(/* webpackPrefetch: true */ `../../classes/universal_methods/setTxtV2.js`)).setTxtV2;

    let output = "";

    const requirementsObj = {
        "past_due": "txt672",
        "eventually_due": "txt673",
        "currently_due": "txt674",
        "pending_verification": "txt675",
        "errors": "txt676"
    };

    for (const key in requirements) {                

        const requirement = requirements[key];

        if( !Array.isArray(requirement) || key == "disabled_reason") continue;
        if(requirement.length < 1) continue;

        let neededInformation = "";

        for (let i = 0; i < requirement.length; i++) {

            if( requirement[i].includes("tos_") ) continue;

            let information = key == "errors" ? requirement[i].reason : requirement[i].replace(".", " ").replace("_", " ");
            // information = information.replace(".", " ").replace("_", " ");
            neededInformation += `<li class="smetio-margin-bottom-10">${information}</li>`;
        };
        
        const headingText = setTxtV2({ attributes: {}, txt:requirementsObj[key], type: "html"});
        const heading = `<h6 class="smetio-h6-heading smetio-margin-bottom-20">${headingText}</h6>`
        output += `<div class="smetio-margin-bottom-20"> 
            ${heading}
            <ul>${neededInformation}</ul> 
        </div>`;
        
    };

    if(output !== "") return output;

    const getCongratulationHeading = (await import(/* webpackPrefetch: true */ `../get/getCongratulationHeading.js`)).getCongratulationHeading;

    return await getCongratulationHeading({txt:"txt677"});

/* 

    return `
        <div>
            <h6 class="smetio-h6-heading smetio-margin-top-20 smetio-text-center smetio-success-text">
                <i class="smetio-icon smetio-icon-check-circle1"></i>
                ${ setTxtV2({ attributes: {}, txt:"txt118", type: "html"}) }
            </h6>

            <p class="smetio-margin-top-10"> ${ setTxtV2({ attributes: {}, txt:"txt677", type: "html"}) } </p>
            
        </div>
    `;
*/    

};
